'use strict';

// Constants
var ATTRIBUTES = {
    CLASSES: {
        ADD_TO_CART: '.add-to-cart',
        ADD_TO_CART_GLOBAL: '.add-to-cart-global',
        INPUT_CONSENT: '#hasConsents',
        PRODUCT_AVAILABILITY: '.product-availability'
    },
    DATA: {
        AVAILABLE: 'available',
        DATA_AVAILABLE: 'data-available'
    },
    PRODUCT_TYPE: {
        SET: 'set'
    },
    VALUE: {
        TRUE: 'true'
    }
};

/**
 * Add to Cart logic to enable or disable button depending on products availability.
 */
function enableAddToCartButton() {
    // Constants
    const $ADD_TO_CART_BUTTONS = $(ATTRIBUTES.CLASSES.ADD_TO_CART).add(ATTRIBUTES.CLASSES.ADD_TO_CART_GLOBAL);
    const $INPUT_CONSENT = $(ATTRIBUTES.CLASSES.INPUT_CONSENT);

    // Variables
    var allAvailable = false;
    var $addToCartButton;
    var allConsents = true;
    var available;
    var hasConsent;
    var isSet;
    var needConsent;
    var pid;
    var readyToOrder;

    // Enable or disabled Product Set "Add All" button depending on child product availability
    if ($(ATTRIBUTES.CLASSES.PRODUCT_AVAILABILITY).toArray().length > 0) {
        allAvailable = $(ATTRIBUTES.CLASSES.PRODUCT_AVAILABILITY)
            .toArray()
            .every(function (item) {
                return $(item).data(ATTRIBUTES.DATA.AVAILABLE);
            });

        $(ATTRIBUTES.CLASSES.ADD_TO_CART_GLOBAL).attr(ATTRIBUTES.DATA.DATA_AVAILABLE, allAvailable);
    }

    if ($ADD_TO_CART_BUTTONS !== null) {
        // Loop through each button to update its state
        $ADD_TO_CART_BUTTONS.each(function () {
            $addToCartButton = this;
            pid = $addToCartButton.dataset.pid;
            hasConsent = null;

            $INPUT_CONSENT.each(function () {
                var element = this;
                if (element.dataset.pid === pid) {
                    hasConsent = element.checked;

                    if (!hasConsent) {
                        allConsents = false;
                    }
                }
            });

            // Check if product is a Set
            isSet = $addToCartButton.dataset.type ? $addToCartButton.dataset.type === ATTRIBUTES.PRODUCT_TYPE.SET : false;

            // Convert true of false variables to Boolean
            needConsent = $addToCartButton.dataset.hasconsents === ATTRIBUTES.VALUE.TRUE;
            available = $addToCartButton.dataset.available === ATTRIBUTES.VALUE.TRUE;
            readyToOrder = $addToCartButton.dataset.readytoorder === ATTRIBUTES.VALUE.TRUE;

            if (
                (available &&
                    readyToOrder &&
                    ((!isSet && !needConsent) || // Not set, doesn't need consent
                        (!isSet && needConsent && hasConsent))) || // Not set, need consent and has consent
                (isSet && readyToOrder && available && allConsents) // Is set
            ) {
                $addToCartButton.disabled = false;
            } else {
                $addToCartButton.disabled = true;
            }
        });
    }
}

/**
 * When product:renderAddToCartValidation is triggered
 */
$('body').on('product:renderAddToCartValidation', function () {
    enableAddToCartButton();
});

module.exports = {
    enableAddToCartButton: enableAddToCartButton,

    /**
     * When hasConsents checkbox is changed
     */
    consentListener: function () {
        $(ATTRIBUTES.CLASSES.INPUT_CONSENT).on('change', function () {
            enableAddToCartButton();
        });
    }
};
